module.exports = __webpack_public_path__ + "static/media/slide4.617e1b23.jpg";